import { Route, Routes } from 'react-router';
import Home from '../pages/Home/Home';
import SignIn from '../pages/Auth/SignIn';
import MapSandbox from '../pages/MapSandbox';
import Order from '../pages/Order';
import OrderSummary from '../pages/OrderSummary';
import Quotes from '../pages/Quotes';
import DevRoutes from '../components/DevRoutes';
import Playground from '../pages/Playground';
import ShopFinder from '../pages/ShopFinder';
import Basket from '../pages/Basket';
import UserPreferences from '../pages/UserPreferences';
import AddressesSection from '../pages/UserPreferences/AddressesSection';
import {
  OrdersSection,
  OrderView,
} from '../pages/UserPreferences/OrdersSection';
import Track from '../pages/Track';
import { InitialSection, TrackSection } from '../pages/Track/components';
import { useAuth } from '../features/Auth';

import {
  ACCOUNT,
  ADDRESSES,
  BASKET,
  DEV,
  DEV_PLAYGROUND,
  DONT_HAVE_ACCESS,
  EMAIL,
  HELP,
  FAQ,
  HOME,
  MAP_SAND_BOX,
  ORDER,
  ORDER_SUMMARY,
  ORDER_VIEW,
  ORDERS,
  PICKUP_FINDER,
  PROFILE,
  QUOTES,
  SHIPMENT,
  SIGN_IN,
  SIGN_UP,
  TRACK,
  TRACK_PARCEL_DETAILS,
  PRODUCTS_AND_SERVICES,
} from '../constants/routes';
import { AccountSection } from '../pages/UserPreferences/AccountSection';
import OverviewSection from '../pages/UserPreferences/OverviewSection/OverviewSection';
import Shipment from '../pages/Shipment';

import {
  ERROR_BOUNDARY_TYPES,
  Error,
  useErrorBoundaryConfigurations,
} from '../features/ErrorBoundary';
import SignUp from '../pages/Auth/SignUp';
import Help from '../pages/Help';
import Faqs from '../pages/Faqs';
import ProductsAndServices from '../pages/ProductAndServices';
import ProtectedRoute from './ProtectedRoute';

function AppRoutes() {
  const { currentSession } = useAuth();
  const getErrorBoundaryConfig = useErrorBoundaryConfigurations();

  return (
    <Routes>
      <Route path={HOME} element={<Home />} />
      <Route path={PRODUCTS_AND_SERVICES} element={<ProductsAndServices />} />
      <Route path={TRACK} element={<Track />}>
        <Route index element={<InitialSection />} />
        <Route path={TRACK_PARCEL_DETAILS} element={<TrackSection />} />
      </Route>
      <Route path={BASKET} element={<Basket />} />
      <Route path={ORDER_SUMMARY} element={<OrderSummary />} />
      <Route path={SHIPMENT} element={<Shipment />} />
      <Route
        path={`${PROFILE}/*`}
        element={<ProtectedRoute element={<UserPreferences />} />}
      >
        <Route index element={<OverviewSection />} />
        <Route path={ACCOUNT} element={<AccountSection />} />
        <Route path={ADDRESSES} element={<AddressesSection />} />
        <Route path={ORDER_VIEW} element={<OrderView />} />
        <Route path={ORDERS} element={<OrdersSection />} />
      </Route>
      <Route path={SIGN_IN}>
        <Route path={EMAIL} element={<SignIn />} />
      </Route>
      <Route path={SIGN_UP} element={<SignUp />} />
      <Route path={MAP_SAND_BOX} element={<MapSandbox />} />
      <Route path={ORDER} element={<Order />} />
      <Route path={QUOTES} element={<Quotes />} />
      <Route path={PICKUP_FINDER} element={<ShopFinder />} />
      <Route path={HELP} element={<Help />} />
      <Route path={FAQ} element={<Faqs />} />
      <Route path={DEV} element={<DevRoutes />}>
        <Route path={DEV_PLAYGROUND} element={<Playground />} />
      </Route>
      <Route
        path={DONT_HAVE_ACCESS}
        element={
          <Error
            config={getErrorBoundaryConfig[
              !currentSession?.uid
                ? ERROR_BOUNDARY_TYPES.DONT_HAVE_ACCESS
                : ERROR_BOUNDARY_TYPES.DONT_HAVE_ACCESS_LOGGED
            ]()}
          />
        }
      />
      <Route path='*' element={<Error />} />
    </Routes>
  );
}

export default AppRoutes;
